(() => {
  'use strict';
  const init = (root = document) => {
    const button = root.querySelector('[data-explain-yourself]');
    if (!button || button.dataset.ready) return;
    const reply = root.querySelector('#NyeBadDecision');
    if (!reply) return;
    button.dataset.ready = 'true';
    button.hidden = false;
    let spriteRequested = false;
    button.addEventListener('click', () => {
      reply.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      button.textContent = 'Yeah. Thought so.';
      const canvas = reply.querySelector('[data-scandal-matt]');
      if (canvas && !spriteRequested) {
        spriteRequested = true;
        const image = new Image();
        image.onload = () => {
          const ctx = canvas.getContext('2d');
          if (!ctx) return;
          // Native frame 24 from Matt's existing performance sprite sheet.
          ctx.clearRect(0, 0, 209, 225);
          ctx.drawImage(image, 0, 842, 209, 200, 0, 25, 209, 200);
        };
        image.onerror = () => { canvas.hidden = true; };
        image.src = canvas.dataset.sprite;
      }
      reply.focus({ preventScroll: true });
      reply.scrollIntoView({ block: 'nearest', behavior: 'auto' });
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
